// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606040558/js/" + chunkId + "." + {"44":"123af1cd","225":"3d30e342","481":"ab4626a6","486":"6f47f63a","770":"2f2c37b8"}[chunkId] + ".0.7525270792656321.chunk.js";
};